import { defineMessages } from 'react-intl';

import * as reportFilters from '../report-filters/constants';

export const defaultMessages = defineMessages({
  [reportFilters.PRODUCT_IMAGES]: {
    defaultMessage: 'Include product images on order details report',
    id: '0RDo6W',
    description: 'Insights > Reports > Filters > PRODUCT_IMAGES > Checkbox > message',
  },
  [reportFilters.ORDER_STATUS]: {
    defaultMessage: 'All Statuses',
    id: 'ek845n',
    description: 'Insights > Reports > Filters > ORDER_STATUS > Dropdown > All Statuses',
  },
  [reportFilters.STORE]: {
    defaultMessage: 'All Stores',
    id: 'pb0CoY',
    description: 'Insights > Reports > Filters > STORE > Dropdown > All Stores',
  },
  [reportFilters.SAVED_ORDER_FILTER]: {
    defaultMessage: 'None',
    id: 'qgO2EZ',
    description: 'Insights > Reports > Filters > SAVED_ORDER_FILTER > None',
  },
  [reportFilters.USER]: {
    defaultMessage: 'Select User',
    id: 'UB7hLL',
    description: 'Insights > Reports > Filters > Select User',
  },
  [reportFilters.INVENTORY_WAREHOUSE]: {
    defaultMessage: 'Select Warehouse',
    id: 'tiO9fE',
    description: 'Insights > Reports > Filters > Select Warehouse',
  },
  [reportFilters.LABEL_PROVIDER]: {
    defaultMessage: 'All Providers',
    id: '42sd5B',
    description: 'Insights > Reports > Filters > All Providers',
  },
  groupByOptionYes: {
    defaultMessage: 'Yes',
    id: 'ml2mch',
    description: 'Insights > Reports > Filters > Group By - yes',
  },
  groupByOptionNo: {
    defaultMessage: 'No',
    id: 'Ac03ZH',
    description: 'Insights > Reports > Filters > Group By - no',
  },
  allProductSkus: {
    defaultMessage: 'All Product SKUs',
    id: 'atnqwo',
    description: 'Insights > Reports > Filters > All Product SKUs',
  },
  activeProductSkus: {
    defaultMessage: 'Active Product SKUs',
    id: 'EUXVT8',
    description: 'Insights > Reports > Filters > Active Product SKUs',
  },
  inActiveProductSkus: {
    defaultMessage: 'Inactive Product SKUs',
    id: '2seuJA',
    description: 'Insights > Reports > Filters > Inactive Product SKUs',
  },
  productRecordSKU: {
    defaultMessage: 'Product Record SKU',
    id: 'qpA2VO',
    description: 'Insights > Reports > Filters > Product Record SKU',
  },
  marketplaceListingSKU: {
    defaultMessage: 'Marketplace Listing SKU',
    id: 'w6FrIc',
    description: 'Insights > Reports > Filters > Marketplace Listing SKU',
  },
  parentRecord: {
    defaultMessage: 'Parent Record',
    id: '8kQUmi',
    description: 'Insights > Reports > Filters > Parent Record',
  },
  allServices: {
    defaultMessage: 'All Services',
    id: 'jFyhiL',
    description: 'Insights > Reports > Filters > All Services',
  },
  allLocations: {
    defaultMessage: 'All Locations',
    id: 'LWTNn7',
    description: 'Insights > Reports > Filters > All Locations',
  },
  allWarehouses: {
    defaultMessage: 'All Inventory Warehouses',
    id: 'J/+ASu',
    description: 'Insights > Reports > Filters > All Inventory Warehouses',
  },
  hotkeyTypeBasic: {
    defaultMessage: 'Basic',
    id: '/rkL+m',
    description: 'Insights > Reports > Filters > Hotkey Type > Basic hotkeys report',
  },
  hotkeyTypeAdvanced: {
    defaultMessage: 'Advanced',
    id: 'Ib0/lH',
    description: 'Insights > Reports > Filters > Hotkey Type > Advanced hotkeys report',
  },
  hotkeyTypeCombined: {
    defaultMessage: 'Basic & Advanced Combined',
    id: 'JHFOum',
    description: 'Insights > Reports > Filters > Hotkey Type > Basic & Advanced Combined hotkeys report',
  },
  scanActionTypeGeneral: {
    defaultMessage: 'General',
    id: 'LQlqWE',
    description: 'Insights > Reports > Filters > Barcode Type > General',
  },
  scanActionShippingPresets: {
    defaultMessage: 'Custom Shipping Presets',
    id: 'umVyxJ',
    description: 'Insights > Reports > Filters > Barcode Type > Shipping Presets',
  },
  scanActionShippingOrders: {
    defaultMessage: 'Shipping Orders',
    id: 'YtoI21',
    description: 'Insights > Reports > Filters > Barcode Type > Shipping Orders',
  },
  scanActionPrintingDocuments: {
    defaultMessage: 'Printing Documents',
    id: '5qf79L',
    description: 'Insights > Reports > Filters > Barcode Type > Printing Documents',
  },
  scanActionNavigation: {
    defaultMessage: 'Navigation',
    id: '0LRtS5',
    description: 'Insights > Reports > Filters > Barcode Type > Navigation',
  },
  [reportFilters.INVOICE_ID]: {
    defaultMessage: 'Enter Invoice Id',
    id: 'vLSQDi',
    description: 'Insights > Reports > Filters > Billing > Enter Invoice Id',
  },
});

export const labelsMessages = defineMessages({
  [reportFilters.SHOW_ACCOUNT_BALANCE_BY]: {
    defaultMessage: 'Filter',
    id: 'mXlT1k',
    description: 'Insights > Reports > Account Balance > Filter',
  },
  [reportFilters.DATE_RANGE]: {
    defaultMessage: 'Date Range',
    id: 'noB9Q5',
    description: 'Insights > Reports > Filters > Date Range',
  },
  [reportFilters.DATE_RANGE_ACTION_DATE]: {
    defaultMessage: 'Date Range (Action Date)',
    id: 'cw+HLH',
    description: 'Insights > Reports > Filters > Date Range (Action Date)',
  },
  [reportFilters.SHIP_DATE]: {
    defaultMessage: 'Ship Date',
    id: 'QhWbTr',
    description: 'Insights > Reports > Filters > Ship Date',
  },
  [reportFilters.GROUP_ITEM_DEMAND_BY]: {
    defaultMessage: 'Group By',
    id: 'Bkf/Wq',
    description: 'Insights > Reports > Filters > Group By',
  },
  [reportFilters.GROUP_PRODUCTS]: {
    defaultMessage: 'Group Products By',
    id: 'i00C4S',
    description: 'Insights > Reports > Filters > Group Products By',
  },
  [reportFilters.INVENTORY_WAREHOUSE]: {
    defaultMessage: 'Inventory Warehouse',
    id: 'BrYVtj',
    description: 'Insights > Reports > Filters > Inventory Warehouse',
  },
  [reportFilters.ORDERED_DURING]: {
    defaultMessage: 'Ordered During',
    id: '+JmLzy',
    description: 'Insights > Reports > Filters > Ordered During',
  },
  [reportFilters.SAVED_ORDER_FILTER]: {
    defaultMessage: 'Order Filter',
    id: 'LM9gV6',
    description: 'Insights > Reports > Filters > Order Filter',
  },
  [reportFilters.ORDER_STATUS]: {
    defaultMessage: 'Order Status',
    id: 'n4MmKn',
    description: 'Insights > Reports > Filters > Order Status',
  },
  [reportFilters.PRODUCT_IMAGES]: {
    defaultMessage: 'Product Images',
    id: 'Ob0kH3',
    description: 'Insights > Reports > Filters > Product Images',
  },
  [reportFilters.LABEL_PROVIDER]: {
    defaultMessage: 'Provider',
    id: 'HDUYvu',
    description: 'Insights > Reports > Filters > Provider',
  },
  [reportFilters.PURCHASED_DURING]: {
    defaultMessage: 'Purchased During',
    id: 'd9j5oA',
    description: 'Insights > Reports > Filters > Purchased During',
  },
  [reportFilters.SERVICE]: {
    defaultMessage: 'Service',
    id: 'J/ML1J',
    description: 'Insights > Reports > Filters > Service',
  },
  [reportFilters.SHIPPED_DURING]: {
    defaultMessage: 'Shipped During',
    id: 'TrXOpN',
    description: 'Insights > Reports > Filters > Shipped During',
  },
  [reportFilters.SHIPPING_ACCOUNT]: {
    defaultMessage: 'Shipping Account',
    id: 'mVM+JR',
    description: 'Insights > Reports > Filters > Shipping Account',
  },
  [reportFilters.SHIPPING_DATE]: {
    defaultMessage: 'Shipping Date',
    id: 'mZ4T9U',
    description: 'Insights > Reports > Filters > Shipping Date',
  },
  [reportFilters.SHIP_FROM_LOCATION]: {
    defaultMessage: 'Ship From Location',
    id: 'hxXJiU',
    description: 'Insights > Reports > Filters > Ship From Location',
  },
  [reportFilters.SHOW_PRODUCTS]: {
    defaultMessage: 'Show Products By',
    id: 'TpifEc',
    description: 'Insights > Reports > Filters > Show Products By',
  },
  [reportFilters.SHOW_PRODUCTS_ALIASES]: {
    defaultMessage: 'Show Product Aliases For',
    id: 'BM2Z6t',
    description: 'Insights > Reports > Filters > Show Product Aliases For',
  },
  [reportFilters.SORT_ITEM_DEMAND_BY]: {
    defaultMessage: 'Sort By',
    id: 'W50paO',
    description: 'Insights > Reports > Filters > Sort By',
  },
  [reportFilters.SPECIFIC_SKU]: {
    defaultMessage: 'Specific SKU',
    id: 'JziE59',
    description: 'Insights > Reports > Filters > Specific SKU',
  },
  [reportFilters.STORE]: {
    defaultMessage: 'Store',
    id: 'scAbxn',
    description: 'Insights > Reports > Filters > Store',
  },
  [reportFilters.USER]: {
    defaultMessage: 'User',
    id: 'rhxZhJ',
    description: 'Insights > Reports > Filters > User',
  },
  [reportFilters.SHOW_PRODUCT_SALES_BY]: {
    defaultMessage: 'Show Products By',
    id: 'TpifEc',
    description: 'Insights > Reports > Filters > Show Products By',
  },
  [reportFilters.SHIPMENT_COUNT_BY_USER_GROUP_BY]: {
    defaultMessage: 'Group By',
    id: 'xXrci9',
    description: 'Insights > Reports > Filters > Shipment Count By User - Group By',
  },
  [reportFilters.USER]: {
    defaultMessage: 'User',
    id: 'rhxZhJ',
    description: 'Insights > Reports > Filters > User',
  },
  [reportFilters.GROUP_BY_PARENT_SKU]: {
    defaultMessage: 'Group Products By Parent SKU',
    id: 'Xemcy4',
    description: 'Insights > Reports > Filters > Group Products By Parent SKU',
  },
  [reportFilters.SHOW_PRODUCT_ALIASES_BY]: {
    defaultMessage: 'Show Product Aliases For',
    id: 'BM2Z6t',
    description: 'Insights > Reports > Filters > Show Product Aliases For',
  },
  [reportFilters.SHOW_SHIPPED_ITEMS_BY]: {
    defaultMessage: 'Show Products By',
    id: 'TpifEc',
    description: 'Insights > Reports > Filters > Show Products By',
  },
  [reportFilters.HOTKEY_TYPE]: {
    defaultMessage: 'Hotkey Type',
    id: 'cvHdTr',
    description: 'Insights > Reports > Filters > Hotkey Type',
  },
  [reportFilters.SHOW_BARCODE_SCAN_ACTION_BY]: {
    defaultMessage: 'Scan Action Type',
    id: '40o+lZ',
    description: 'Insights > Reports > Filters > Scan Action Type',
  },
  shouldShowHotkeysLabel: {
    defaultMessage: 'Show Hotkeys in Report',
    id: 'lysQmN',
    description: 'Insights > Reports > Filters > Should Show Hotkeys',
  },
  showHotkeysLabel: {
    defaultMessage: 'Show Hotkeys',
    id: 'UwHDQN',
    description: 'Insights > Reports > Filters > Show Hotkeys',
  },
  [reportFilters.LOT]: {
    defaultMessage: 'Lot ID (Required)',
    id: '33qQtr',
    description: 'Identification number assigned to a particular quantity or lot of material from a single manufacturer.',
  },
  [reportFilters.INVOICE_ID]: {
    defaultMessage: 'Enter Invoice Id',
    id: 'vLSQDi',
    description: 'Insights > Reports > Filters > Billing > Enter Invoice Id',
  },
  dateRangeDisabled: {
    defaultMessage: 'Disabled',
    id: 'QOZbPe',
    description: 'Label for disabled date range filter option',
  },
});
